import _ from 'lodash'
import Config from '@/api/config'
import Moment from 'moment'

const logApi = !!(process.env.NODE_ENV !== 'production')

class Express {
  constructor () {
    this.requestBody = {
      merchantTransactionID: '',
      customerFirstName: 'John',
      customerLastName: 'Smith',
      MSISDN: '',
      customerEmail: '',
      requestAmount: '',
      currencyCode: '',
      accessKey: '',
      ivKey: '',
      secretKey: '',
      serviceCode: '',
      accountNumber: (new Date()).getTime(),
      dueDate: Moment((new Date((new Date()).getTime() + (15 * 60 * 1000)))).utc().format('YYYY-MM-DD HH:mm:ss'),
      requestDescription: 'This is a test visit for the customer last',
      countryCode: '',
      successRedirectUrl: Config.EXPRESS_CALLBACK_URL,
      failedRedirectUrl: Config.EXPRESS_CALLBACK_URL,
      paymentWebhookUrl: Config.PAYMENT_WEBHOOK_URL
    }
  }

  encrypt () {
    return fetch(Config.ENGINE_PROXY_URL + 'encrypt', {
      method: 'POST',
      body: JSON.stringify(this.requestBody),
      mode: 'cors'
    }).then(response => response.json())
  }

  initialize (request) {
    _.forIn(request, (value, key) => {
      this.requestBody[key] = value
    })
    return this
  }

  redirect ({ accessKey, ivKey, secretKey }) {
    this.requestBody = _.assign(this.requestBody, { accessKey, ivKey, secretKey })
    logApi && console.log('Payload to send for encryption => ', this.requestBody)
    this.encrypt().then(merchantProperties => {
      logApi && console.log('Merchant properties => ', merchantProperties)
      window.Tingg.renderCheckout({merchantProperties: merchantProperties, checkoutType: 'redirect'})
    })
  }
}

export default (new Express())



// WEBPACK FOOTER //
// ./src/api/utilities/Express.js